<app-back-toolbar *ngIf="isBackOfficeLayout" [userName]="backUsername" [imgURL]="backToolbarImage" [dropdownMenu]="backToolbarDropdownMenu">
</app-back-toolbar>
<div>
<app-front-contact-navbar *ngIf="isFrontOfficeLayout && !isMobile " [userName]="backUsername" [imgURL]="backToolbarImage" [dropdownMenu]="backToolbarDropdownMenu">
</app-front-contact-navbar>
<app-front-navbar *ngIf="isFrontOfficeLayout" [logoURL]="logo.url" [menuTree]="frontMenuTree" [NosSolution]="NosSolution" [button]="frontButton">
</app-front-navbar>
</div>
<app-back-navbar *ngIf="isBackOfficeLayout" [copyright]="backCopyright" [logo]="logo" [menuTree]="backMenuTree">
</app-back-navbar>